'use client';
import React, { useState } from 'react';
import Image from 'next/image';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slider from 'react-slick';
import researchBenefits from '../../../../../data/researchBenefits';
import Worldwide from '@images/worldwide.svg';
import Countries from '@images/countries.svg';
import People from '@images/people.svg';
import TransformingLives from '@images/transforming-lives.svg';

export default function AboutUsPage() {
  const researchBenefitsSliderSettings = {
    dots: false,
    infinite: false,
    slidesToShow: 4.3,
    slidesToScroll: 3,
    arrows: true,
    autoplay: false,
    autoplaySpeed: 5000,
    speed: 600,
    cssEase: 'linear',
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 4.3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3.1,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2.3,
          slidesToScroll: 1,
        },
      },

      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.5,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 375,
        settings: {
          slidesToShow: 1.3,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const YouTubeModal = ({ isOpen, onRequestClose, videoId }) => {
    if (!isOpen) return null;

    return (
      <div className="modal-overlay modal--youtube" onClick={onRequestClose}>
        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
          <button className="close-button" onClick={onRequestClose}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              width="25"
              height="25"
              viewBox="0 0 35 35"
              fill="#FFFFFF"
            >
              <path d="M 9.15625 6.3125 L 6.3125 9.15625 L 22.15625 25 L 6.21875 40.96875 L 9.03125 43.78125 L 25 27.84375 L 40.9375 43.78125 L 43.78125 40.9375 L 27.84375 25 L 43.6875 9.15625 L 40.84375 6.3125 L 25 22.15625 Z"></path>
            </svg>
          </button>
          <div className="video-wrapper">
            <iframe
              width="560"
              height="315"
              src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </div>
    );
  };
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const openModal = () => setModalIsOpen(true);
  const closeModal = () => setModalIsOpen(false);
  return (
    <main className="page-research-sudarshan-kriya">
      <section className="research-banner">
        <div className="container">
          <div className="banner-title font-lora">SKY Breath Meditation</div>
          <div className="banner-description font-lora">
            SKY, or Sudarshan Kriya™, is evidence-based breathwork that
            works—from day one.
          </div>
          <div className="key-highlights">
            <div className="item">
              <Image
                src="/images/research-banner-icon1.png"
                alt="Research Icon"
                width={44}
                height={44}
                className="research-banner-icon"
              />
              Reduces stress, anxiety, burnout
            </div>
            <div className="item">
              <Image
                src="/images/research-banner-icon2.png"
                alt="Research Icon"
                width={44}
                height={44}
                className="research-banner-icon"
              />
              Increases energy levels
            </div>
            <div className="item">
              <Image
                src="/images/research-banner-icon3.png"
                alt="Research Icon"
                width={44}
                height={44}
                className="research-banner-icon"
              />
              Improves sleep
            </div>
          </div>
          <div className="banner-action">
            <a
              className="banner-btn"
              href={`${process.env.NEXT_PUBLIC_AUTH_APP_URL}/us-en/course/scheduling?utm_page=research`}
            >
              Learn it today
            </a>
          </div>
        </div>
      </section>
      <section className="featured-in">
        <div className="container">
          <picture>
            <source
              media="(max-width: 768px)"
              srcSet="/images/research-featured-in-mobile.jpg"
            />
            <Image
              src="/images/research-featured-in.png"
              alt="Featured In"
              className="featured-in-image"
              width={1124}
              height={274}
            />
          </picture>
        </div>
      </section>
      <section className="section-breathing-hack">
        <div className="container">
          <div className="section-title">
            A Life-Changing Breathing Practice—Grounded in Science
          </div>
          <div className="video-container">
            <iframe
              src="https://player.vimeo.com/video/1035699838?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;wmode=opaque"
              allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
              title="Does Breathwork Really Work_ When You've Got The Right Technique...YES!"
              width="100%"
              height="100%"
            ></iframe>
          </div>
          <div className="video-content">
            <p>
              <a
                className="link-highlighted"
                href={`${process.env.NEXT_PUBLIC_AUTH_APP_URL}/us-en/course/scheduling?utm_page=research`}
              >
                <strong>SKY Breath Meditation</strong>
              </a>{' '}
              is a breathing technique that&apos;s been learned by millions of
              people from around the globe,{' '}
              <em>from every background imaginable</em> (Actually, everyone from
              rural farmers in South America to Manhattan CEOs).
            </p>
            <p>And it&apos;s worked again and again.</p>
          </div>
        </div>
      </section>
      <section className="section-modern-science">
        <div className="container">
          <div className="box-modern-science">
            <div className="box-inner">
              <div className="section-title">
                Modern Science Meets Ancient Breath
              </div>
              <div className="box-image">
                <Image
                  src="/images/ancient-breath.jpg"
                  alt="Ancient Breath"
                  width={521}
                  height={403}
                  className="modern-image"
                />
              </div>
              <div className="box-content">
                <div className="section-title">
                  Modern Science Meets Ancient Breath
                </div>
                <p>
                  This powerful rhythmic breathing exercise harmonizes the
                  body-mind complex. Participants notice reduced stress and
                  anxiety, better sleep, a stronger immune system, and increased
                  energy levels.
                </p>
                <p>
                  <strong>And researchers have noticed it too…</strong>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="section-evidence">
        <div className="container">
          <div className="section-title">
            Evidence-Based: Scientific Studies Show the Effectiveness of SKY
          </div>
          <Image
            src="/images/cambridge-yale-standford.webp"
            alt="Universities"
            width={337}
            height={100}
            className="university-image"
          />
          <div className="evidence-text">
            Explore the benefits of SKY Breath Meditation (aka Sudarshan Kriya
            Yoga), as seen in <strong>100+ research studies</strong> from
            institutions like <strong>Yale, Stanford</strong> and the{' '}
            <strong>University of Wisconsin</strong> and published in
            peer-reviewed journals across four continents.
          </div>
        </div>
      </section>
      <section className="section-impact">
        <div className="container">
          <div className="section-title">
            Impact of SKY on Health and Wellbeing
          </div>
          <div className="section-desc">
            Science-backed benefits of SKY, taught in the Art of Living Part 1,
            shown in&nbsp;
            <a
              href="https://www.artoflivingresearch.org/research-summary"
              target="_blank"
            >
              over 100 independent studies
            </a>
          </div>
          <div className="impact-stats">
            <div className="item">
              <div className="first-row">
                <Image
                  src="/images/research-stats-up-arrow.png"
                  alt="up arrow"
                  width={36}
                  height={58}
                  className="stat-icon"
                />
                <span className="item-number">37%</span>
              </div>
              <div className="second-row">
                increased calm in 4 weeks
                <sup>
                  <a
                    href="https://www.ncbi.nlm.nih.gov/pmc/articles/PMC4728954/"
                    target="_blank"
                  >
                    1
                  </a>
                </sup>
              </div>
            </div>
            <div className="item">
              <div className="first-row">
                <Image
                  src="/images/research-stats-down-arrow.png"
                  alt="down arrow"
                  width={36}
                  height={58}
                  className="stat-icon"
                />
                <span className="item-number">53%</span>
              </div>
              <div className="second-row">
                reduced anxiety in 8 weeks
                <sup>
                  <a
                    href="https://jamanetwork.com/journals/jamanetworkopen/fullarticle/2814344"
                    target="_blank"
                  >
                    2
                  </a>
                </sup>
              </div>
            </div>
            <div className="item">
              <div className="first-row">
                <Image
                  src="/images/research-stats-down-arrow.png"
                  alt="down arrow"
                  width={36}
                  height={58}
                  className="stat-icon"
                />
                <span className="item-number">31%</span>
              </div>
              <div className="second-row">
                reduction in insomnia
                <sup>
                  <a
                    href="https://pubmed.ncbi.nlm.nih.gov/32881710/"
                    target="_blank"
                    className="underline text-[#ff7e00] font-semibold"
                  >
                    3
                  </a>
                </sup>
              </div>
            </div>
            <div className="item">
              <div className="first-row">
                <Image
                  src="/images/research-stats-down-arrow.png"
                  alt="down arrow"
                  width={36}
                  height={58}
                  className="stat-icon"
                />
                <span className="item-number">57%</span>
              </div>
              <div className="second-row">
                reduction in stress hormone "cortisol" in 2 weeks
                <sup>
                  <a
                    href="https://pubmed.ncbi.nlm.nih.gov/16740317/"
                    target="_blank"
                    className="underline text-[#ff7e00] font-semibold"
                  >
                    4
                  </a>
                </sup>
              </div>
            </div>
            <div className="item">
              <div className="first-row">
                <Image
                  src="/images/research-stats-down-arrow.png"
                  alt="down arrow"
                  width={36}
                  height={58}
                  className="stat-icon"
                />
                <span className="item-number">36%</span>
              </div>
              <div className="second-row">
                decreased cholesterol in 6 weeks
                <sup>
                  <a
                    href="https://pubmed.ncbi.nlm.nih.gov/22346062/"
                    target="_blank"
                    className="underline text-[#ff7e00] font-semibold"
                  >
                    12
                  </a>
                </sup>
              </div>
            </div>
            <div className="item">
              <div className="first-row">
                <Image
                  src="/images/research-stats-down-arrow.png"
                  alt="down arrow"
                  width={36}
                  height={58}
                  className="stat-icon"
                />
                <span className="item-number">52%</span>
              </div>
              <div className="second-row">
                reduced depression in 8 weeks
                <sup>
                  <a
                    href="https://jamanetwork.com/journals/jamanetworkopen/fullarticle/2814344"
                    target="_blank"
                    className="underline text-[#ff7e00] font-semibold"
                  >
                    2
                  </a>
                </sup>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="section-research-benefits">
        <div className="container">
          <div className="section-title">
            Research Proves SKY Enhances Mental and Emotional Wellness
          </div>
          <div className="section-desc">
            Multiple studies suggest SKY as a promising adjuvant drug-free
            treatment option for anxiety and depression (
            <a
              href="https://pubmed.ncbi.nlm.nih.gov/26142611/"
              target="_blank"
              className="underline"
            >
              5
            </a>
            ,{' '}
            <a
              href="https://pubmed.ncbi.nlm.nih.gov/27898207/"
              target="_blank"
              className="underline"
            >
              6
            </a>
            ,{' '}
            <a
              href="https://pubmed.ncbi.nlm.nih.gov/28285240/"
              target="_blank"
              className="underline"
            >
              7
            </a>
            ,{' '}
            <a
              href="https://www.sciencedirect.com/science/article/pii/S0304394019303738?via%3Dihub#bib0045"
              target="_blank"
              className="underline"
            >
              8
            </a>
            ).
          </div>
          <div className="research-benefit-tiles">
            <Slider {...researchBenefitsSliderSettings}>
              {researchBenefits.map((item, index) => (
                <div key={index} className="research-benefit-tile">
                  <div className="flip-card">
                    <div
                      className="flip-card-inner"
                      style={{
                        backgroundColor: `${item.bgColor}`,
                        borderBottom: `${item.borderColor} 8px solid`,
                      }}
                    >
                      <div className="flip-card-front">
                        <Image
                          src={item.img}
                          alt={item.front_name}
                          height={150}
                          width={150}
                          className="tile-image"
                        />
                        <div className="font-lora title">{item.front_name}</div>
                        <div className="desc">{item.front_desc} </div>{' '}
                      </div>
                      <div className="flip-card-back">
                        <div className="font-lora title">{item.back_name}</div>
                        <div className="desc">{item.back_desc} </div>
                      </div>
                    </div>
                  </div>{' '}
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </section>
      <section className="section-about-sky">
        <div className="container">
          <div className="section-title">Scientists Raving About SKY</div>
          <div className="about-video-container">
            <div className="video-container">
              <iframe
                width="560"
                height="315"
                src="https://www.youtube.com/embed/Uvli7NBUfY4?si=ZjiAtlB2hcPk7PiS"
                title="YouTube video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              ></iframe>
            </div>
            <div className="video-content">
              <div className="video-title font-lora">
                &quot;The breath is a powerful tool to calm the mind and unlock
                happiness.&quot;
              </div>
              <div className="video-author">— Dr. Emma Seppälä</div>
              <div className="video-author-position">
                Best-selling author, Yale lecturer, international keynote
                speaker
              </div>
            </div>
          </div>
          <div className="about-video-container">
            <div className="video-container">
              <iframe
                width="560"
                height="315"
                src="https://www.youtube.com/embed/76sTPIt_onw?si=o3Qj3SWcOzVsGWy2"
                title="YouTube video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              ></iframe>
            </div>
            <div className="video-content">
              <div className="video-title font-lora">
                “No matter what you eat, how much you exercise, how skinny or
                young or strong you are, none of it matters if you’re not
                breathing properly.”
              </div>
              <div className="video-author">— James Nestor</div>
              <div className="video-author-position">
                Award-winning science journalist and NYT best-selling author
              </div>
            </div>
          </div>
          <div className="about-video-container">
            <div className="video-container">
              <iframe
                width="560"
                height="315"
                src="https://www.youtube.com/embed/eYUZrOQETfs?si=Z2s-QpAqdoDFyBpK"
                title="YouTube video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              ></iframe>
            </div>
            <div className="video-content">
              <div className="video-title font-lora">
                “A promising way to reduce stress and burnout.”
              </div>
              <div className="video-author">- Asli Korkmaz, MSc, et al</div>
              <div className="video-author-position">
                Published in{' '}
                <a
                  href="https://jamanetwork.com/journals/jamanetworkopen/fullarticle/2814344"
                  target="_blank"
                  className="underline"
                >
                  JAMA Network Open, 2024
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="section-mindfulness">
        <div className="container">
          <div className="mindfulness-row">
            <div className="mindfulness-col-1">
              <div className="title">
                SKY Breathing tops Mindfulness and Emotional Intelligence.
              </div>
              <p>
                Yale University researchers found that when SKY was compared
                with Mindfulness and Emotional Intelligence techniques,
                <a
                  href="https://www.ncbi.nlm.nih.gov/pmc/articles/PMC7373803/"
                  target="_blank"
                  className="underline"
                >
                  {' '}
                  SKY practitioners benefitted the most on mental health
                </a>
                , positivity, stress, and social connection.
              </p>
              <p>
                Explore additional SKY research at:&nbsp;
                <a
                  href="https://www.artoflivingresearch.org/"
                  target="_blank"
                  className="underline"
                >
                  www.artoflivingresearch.org
                </a>
              </p>
            </div>
            <div className="mindfulness-col-2">
              <div className="mindfulness-video-thumb">
                <Image
                  src="/images/sky-tumbnail.png"
                  alt="SKY Breathing tops Mindfulness and Emotional Intelligence."
                  height={250}
                  width={370}
                />
                <Image
                  src="/images/play-icon-yellow.png"
                  alt="SKY Breathing tops Mindfulness and Emotional Intelligence. play icon"
                  height={80}
                  width={80}
                  onClick={openModal}
                  className="absolute bottom-0 right-0 cursor-pointer"
                />
                <YouTubeModal
                  isOpen={modalIsOpen}
                  onRequestClose={closeModal}
                  videoId="Vlu3arLc0WE" // Replace with your YouTube video ID
                />
              </div>
            </div>
            <div className="mindfulness-mobile-col">
              <p>
                Explore additional SKY research at:&nbsp;
                <a
                  href="http://www.aolresearch.org/"
                  target="_blank"
                  className="underline"
                >
                  http://www.aolresearch.org/
                </a>
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="section-people-sharing">
        <div className="container">
          <div className="section-title">What people are sharing</div>
          <div className="testimonials">
            <div className="testimony">
              <div className="testimony-text">
                “I had been overwhelmed with fear and anxiety. Doing this course
                online has made all the difference. I felt calm and peaceful,
                and finally had a good night’s sleep. Doing the practice every
                day is a real life saver for me!”
              </div>
              <div className="testimony-author">-Jane</div>
            </div>
            <div className="testimony">
              <div className="testimony-text">
                "I used to think these practices were for people who have too
                much time, but it's the opposite. I have a lot to do and I have
                to be effective as a leader. SKY gives me the drive and energy I
                need to keep going."
              </div>
              <div className="testimony-author">-Arpit</div>
            </div>
            <div className="testimony">
              <div className="testimony-text">
                “It was awesome! I regained my mental health. And I also feel so
                much lighter and happier. I got out of my funk that was getting
                me unmotivated.”
              </div>
              <div className="testimony-author">-Joanna</div>
            </div>
          </div>
        </div>
      </section>
      <section className="section-aol-stats">
        <div className="container">
          <div className="stats-listing">
            <div className="stats-item">
              <div className="stat-icon">
                <Image
                  src={TransformingLives}
                  alt="Transforming Lives"
                  width={88}
                  height={103}
                  className="stat-icon"
                />
              </div>
              <div className="stat-content">
                <div className="stat-title">
                  43 <span>Years</span>
                </div>
                <div className="stat-desc">of transforming lives</div>
              </div>
            </div>
            <div className="stats-item">
              <div className="stat-icon">
                <Image
                  src={Worldwide}
                  alt="Worldwide"
                  width={88}
                  height={88}
                  className="stat-icon"
                />
              </div>
              <div className="stat-content">
                <div className="stat-title">
                  10,000+ <span>Centers</span>
                </div>
                <div className="stat-desc">worldwide</div>
              </div>
            </div>
            <div className="stats-item">
              <div className="stat-icon">
                <Image
                  src={Countries}
                  alt="Countries"
                  width={95}
                  height={95}
                  className="stat-icon"
                />
              </div>
              <div className="stat-content">
                <div className="stat-title">
                  182 <span>Countries</span>
                </div>
                <div className="stat-desc">
                  where our programs made a difference
                </div>
              </div>
            </div>
            <div className="stats-item">
              <div className="stat-icon">
                <Image
                  src={People}
                  alt="Lives"
                  width={88}
                  height={88}
                  className="stat-icon"
                />
              </div>
              <div className="stat-content">
                <div className="stat-title">
                  800M+ <span>Lives</span>
                </div>
                <div className="stat-desc">
                  touched through our courses & events
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="section-gurudev-quote">
        <div className="container">
          <div className="quote-text font-lora">
            “Every emotion is connected with the breath. If you can change the
            breath's rhythm, you can change the emotion.”
          </div>
          <div className="quote-author">Gurudev, Art of Living Founder</div>
        </div>
      </section>
      <section className="section-ready-to-find">
        <div className="container">
          <div className="find-out-box">
            <div className="find-out-box-inner">
              <div className="find-out-text font-lora">
                Ready to find out first-hand what SKY can do for you?
              </div>
              <div className="find-out-action-wrap">
                <a
                  className="btn"
                  href={`${process.env.NEXT_PUBLIC_AUTH_APP_URL}/us-en/course/scheduling?utm_page=research`}
                >
                  Find your course today
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="section-faq">
        <div className="container">
          <div className="subtitle">FAQ</div>
          <div className="section-title">Frequently Asked Questions</div>
          <ul id="faq">
            <li>
              <input type="checkbox" />
              <h2>
                <span className="font-lora">
                  What is the duration of the Art of Living Part 1 Course?
                </span>
                <i></i>
              </h2>
              <p>
                You can learn the Sudarshan Kriya™ practice taught in the Art of
                Living-Part I Course in 3 days with 2.5 hours of live online or
                in-person sessions each day with a certified instructor.
              </p>
            </li>
            <li>
              <input type="checkbox" />
              <h2>
                <span className="font-lora">
                  What are the benefits of Sudarshan Kriya™?
                </span>
                <i></i>
              </h2>
              <p>
                Sudarshan Kriya™ taught in the Art of Living Part 1 course has
                been researched in over 100 independent studies and shown
                significant mind and body benefits. It lowers stress levels,
                improves mental clarity, enhances emotional well-being,
                contributes to better sleep, raises energy levels, and provides
                a greater sense of inner peace. The physical benefits include
                boosting immunity, heart health, and more.
              </p>
            </li>
            <li>
              <input type="checkbox" />
              <h2>
                <span className="font-lora">
                  Can I reschedule my Art of Living Part 1 Course after my
                  initial registration?
                </span>
                <i></i>
              </h2>
              <p>
                Yes, you can reschedule to a different Art of Living Part 1
                course if you are unable to attend the original dates selected.
              </p>
            </li>
            <li>
              <input type="checkbox" />
              <h2>
                <span className="font-lora">
                  Is there an age requirement to attend the Art of Living Part 1
                  Course?
                </span>
                <i></i>
              </h2>
              <p>
                Yes, you must be at least 18 years old to attend. The Art of
                Living offers alternative programs for kids and teens (18 years
                and under). Contact us at youthprograms@iahv.org to learn more.
              </p>
            </li>
            <li>
              <input type="checkbox" />
              <h2>
                <span className="font-lora">
                  What’s the cost of the Art of Living Part 1 Course?
                </span>
                <i></i>
              </h2>
              <p>
                The Art of Living Part 1 course is available in two formats: a
                3-day online course for $295 and an in-person course for $395.
                <br />
                <br />
                What’s included: <br />
                • 2.5 hour daily live sessions
                <br />
                • certified expert instruction
                <br />
                • guided techniques with Q&amp;A
                <br />
                • real-time support
                <br />
                • interactive wisdom sessions
                <br />
                • small group size
                <br />
                <br />
                <br />
                You’ll gain a life-transforming breathwork technique backed by
                over 100+ independent studies you can practice anytime you need.
                <br />
                <br />
                *A one-time payment for a LIVE course, and not a subscription.
              </p>
            </li>
          </ul>
        </div>
      </section>
    </main>
  );
}
